<template>
  <div :class="['form-response', {'error': errored}]">
    <SvgIcon :name="errored ? 'func_close' : 'approve'" class="icon" />
    <div v-if="title || description" class="message">
      <h2>{{ displayedTitle }}</h2>
      <p>{{ description }}</p>
    </div>
    <SimpleButton v-if="ctaLabel" class="cta" xl @click="$emit('click')">{{ ctaLabel }}</SimpleButton>
  </div>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: false,
    default: ""
  },
  ctaLabel: {
    type: String,
    required: false,
    default: ""
  },
  errored: {
    type: Boolean,
    required: false,
  }
})

defineEmits(['click']);


const displayedTitle= computed(() => {
  if (
    props.errored &&
    props.title.toLowerCase().includes('captcha')
  ) {
    return 'Captcha validation failed.';
  }

  return props.title;
});
</script>

<style lang="scss" scoped>
.form-response {
  flex: 1;
  justify-content: center;
  align-items: center;
  text-align: center;
  --parent-bg: #fff;

  @include for-tablet-landscape-up {
    width: 30rem;
  }

  &, .message {
    display: flex;
    flex-direction: column;
  }

  .icon {
    width: 4rem;
    height: 4rem;
  }

  &.error .icon {
    :deep(path), :deep(rect) {
      stroke: var(--form-field-label-error);
    }
  }

  .message {
    gap: 0.5rem;
    margin-top: 1.5rem;

    @include for-tablet-landscape-up {
      gap: 1rem;
      margin-top: 2.5rem;
    }
  }

  .cta {
    margin-top: 2rem;

    @include for-tablet-landscape-up {
      margin-top: 4rem;
    }
  }
}
</style>
